// extracted by mini-css-extract-plugin
export default {"container":"TimerMessage_container__kFqoQ"};